var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mine"},[_c('top-nav',{attrs:{"banner":_vm.mechanicalVehicle.banner,"isParent":""}}),_vm._v(" "),_c('pain'),_vm._v(" "),_c('Introduction'),_vm._v(" "),_c('comm-scene',{attrs:{"dataKey":'mine'}}),_vm._v(" "),_c('product-list'),_vm._v(" "),_c('customer-wall'),_vm._v(" "),_c('footer-resolution'),_vm._v(" "),_c('my-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }